import styled, { css } from 'styled-components';

export const PageHeader = styled.div`
  min-height: 13.2rem;
  width: 100%;
  background: #242424;

  padding: 0 5.6rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media (max-width: 768px) {
    padding: 0 2.5rem;
  }
`;

export const PageHeaderBackButton = styled.div`
  display: flex;
  flex-direction: row;
  font-size: 25px;
  align-items: center;
  justify-content: center;
  color: #ffdf22;
  cursor: pointer;
  letter-spacing: 1.25px;
`;

export const PageHeaderBackButtonLabel = styled.div`
  font-weight: bold;
  padding-left: 5px;
  text-transform: uppercase;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Wrapper = styled.div`
  @media (max-width: 768px) {
    display: flex;
  }
`;

export const ProgramInfo = styled.div`
  display: flex;
  margin-top: 1.4rem;

  @media (max-width: 768px) {
    margin-top: 0rem;
    margin-left: 2.5rem;
  }
`;

export const Billing = styled.button`
  color: #fff;
  margin-right: 2.8rem;
  background: transparent;
  font-size: 1.8rem;
`;

export const Program = styled.div`
  color: #fff;
  font-size: 1.8rem;
`;

export const HeaderButtons = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  font-size: 0px;

  display: flex;
  flex-direction: column;
  justify-content: space-around;

  margin: 0.8rem 0;

  > a,
  button {
    display: flex;
    align-items: center;
    justify-content: center;

    color: #fff;

    padding: 0.4rem;

    border-radius: 0.2rem;

    transition: ${({ theme }) => theme.transition.default};

    :hover {
      transform: scale(1.05);
    }

    :active {
      transform: scale(0.99);
    }
    background: transparent linear-gradient(155deg, #ffdf22 0%, #ffd503 100%);

    /* :last-child {
      background: transparent linear-gradient(155deg, #b50808 0%, #d90606 100%);
    } */
  }

  @media (min-width: 425px) {
    > a,
    button {
      border-radius: 50%;
    }
  }

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: baseline;

    margin: 0;

    > a,
    button {
      min-width: 3.3rem;
      min-height: 3.3rem;
    }

    > button {
      margin-top: 0rem;
      margin-left: 1.6rem;
    }
  }
`;

export const Container = styled.div`
  flex: 1;
`;

export const NewButtonContainer = styled.div`
  margin: 3.8rem 5.8rem;

  @media (max-width: 768px) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2.5rem 0;
  }
`;

export const NewButton = styled.button`
  color: #000;
  width: 328px;
  height: 50px;
  background: transparent linear-gradient(90deg, #ffd503 0%, #ffdf22 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 50px;
  opacity: 1;
  font-size: 19px;

  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 768px) {
    width: 250px;
    height: 50px;
  }

  &:hover {
    filter: brightness(0.9);
  }
`;

export const NewButtonLabel = styled.div`
  text-transform: uppercase;
  font-weight: bold;
  padding-left: 5px;
`;

export const Section = styled.section`
  margin: 3.8rem 5.8rem;

  display: flex;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    justify-content: center;
  }
`;

export const Message = styled.p`
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 15rem;
  color: #fff;
  font-size: 2.2rem;
`;

interface RadioOptionProps {
  isSelected: boolean;
}

export const RadioInput = styled.button.attrs({
  type: 'button',
})<RadioOptionProps>`
  display: flex;
  align-items: center;
  background: none;

  padding: 0 1.7rem;
  margin-bottom: 0.6rem;

  .radio {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 2.2rem;
    height: 2.2rem;
    border: 1px solid #000;
    border-radius: 50%;

    background: transparent;

    margin-right: 0.5rem;

    transition: ${({ theme }) => theme.transition.default};

    .filled {
      width: 1.4rem;
      height: 1.4rem;
      border-radius: inherit;

      background: ${({ isSelected }) => (isSelected ? '#000' : '#fff')};
    }
  }

  > p {
    color: #000;
    transition: ${({ theme }) => theme.transition.default};
  }

  &:hover {
    .radio {
      border-color: #000;
    }

    > p {
      color: #000;
    }
  }
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    text-transform: uppercase;
    margin-bottom: 2rem;
  }
`;

export const FieldSet = styled.fieldset`
  border: none;
  display: flex;
  flex-direction: column;
  width: 100%;

  margin-bottom: 2.6rem;

  div {
    border-radius: 2rem;
  }
`;

export const FieldSetWrapper = styled.div``;

type FieldTitleProps = {
  secondary?: boolean;
};

export const FieldTitle = styled.span<FieldTitleProps>`
  font-size: 2.1rem;
  font-weight: bold;

  margin-bottom: 1.6rem;

  ${(props) =>
    props.secondary &&
    css`
      font-size: 1.8rem;
      padding: 0 1.9rem;

      margin-bottom: 0.5rem;
    `}
`;

export const FormContainer = styled.div`
  width: 100%;
`;

export const RedirectModalContainer = styled.p`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  h1 {
    text-transform: uppercase;
    margin-bottom: 2rem;
  }

  div {
    font-size: 2rem;
    padding-bottom: 3rem;
  }

  button {
    width: 60%;
  }
`;
